import React from "react"
import { Box, AspectRatio, Button, Heading, Text } from "@chakra-ui/react"

import Image from "@components/Image/Image"
import Link from "@components/Link"
import { HeroSlideProps } from "./Hero"
import { ContentBoxMobile } from "./Styles"

const HeroSlideMobile = ({ slide, handleTrackingClick }: HeroSlideProps) => {
  const hasLink = slide?.externalLink ? slide?.externalLink : slide.link?.url
  const hasContent = slide.title || slide.content

  const image = (
    <Image
      src={slide?.image?.mobile?.src}
      alt={slide?.image?.mobile?.alt}
      maxHeight={`100%`}
      w={hasContent && "full"}
      h={hasContent && "full"}
    />
  )
  const content = hasContent ? (
    <Box>
      {slide?.image?.dimensions?.aspectRatio ? <AspectRatio ratio={slide?.image?.dimensions?.aspectRatio}>{image}</AspectRatio> : image}
      <ContentBoxMobile>
        <Box>
          <Heading size="h2" color="white">
            {slide.title}
          </Heading>
          <Text size="md" color="white">
            {slide.content}
          </Text>
        </Box>
        {hasLink && <Button variant="blue">{slide.link.title}</Button>}
      </ContentBoxMobile>
    </Box>
  ) : slide?.image?.dimensions?.aspectRatio ? (
    <AspectRatio ratio={slide?.image?.dimensions?.aspectRatio}>{image}</AspectRatio>
  ) : (
    image
  )

  return hasLink ? (
    <Link to={hasLink} onClick={handleTrackingClick}>
      {content}
    </Link>
  ) : (
    content
  )
}

export default React.memo(HeroSlideMobile)
